import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportDiarioObraIndividualUseCase } from "../../../presentation/useCases/read/get_report_diario_obra_individual_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportDiarioObraIndividualUseCase implements IGetReportDiarioObraIndividualUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportDiarioObraIndividual(
    requiredMimeType: ReportMimeType | null,
    IdDiarioObra: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportDiarioObraIndividual(
      requiredMimeType,
      IdDiarioObra,
    );

    if (response.mimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `diario_obra_individual_${IdDiarioObra}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
